"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserOrgMapDTO = exports.UserOrgMapDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.UserOrgMapDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    additionalProperties: {
        type: "string",
    },
    defaultProperties: [],
    type: "object",
};
exports.isUserOrgMapDTO = exports.ajv.compile(exports.UserOrgMapDTOSchema);
function validate(value) {
    if (exports.isUserOrgMapDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isUserOrgMapDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "UserOrgMapDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=UserOrgMap.validator.js.map